module.exports = __webpack_public_path__ + "static/media/offlineLocationMarker.2b3711af.svg";